<div
  class="border rounded-lg p-4 border-outline dark:border-outline-darkmode bg-surface-magic dark:bg-surface-magic-darkmode flex flex-col gap-4"
>
  <div class="flex gap-2">
    <div
      class="inline-block border border-outline rounded-lg p-2.5 dark:border-outline-darkmode flex-none"
    >
      <ng-icon name="heroDocument" size="20" class="!block" />
    </div>
    <div class="flex-1 flex flex-col text-sm">
      <div class="font-semibold leading-5 line-clamp-1">
        {{ titleText() }}
      </div>
      <div
        class="leading-5 line-clamp-1 text-on-surface-variant dark:text-on-surface-variant-darkmode"
      >
        {{ subtitle() }}
      </div>
    </div>
    @if (error()) {
      <ui-button
        type="button"
        size="small"
        mode="outlined"
        [iconOnly]="true"
        (click)="clickRetry.emit()"
      >
        <ng-icon name="heroArrowPath" size="20" class="!block" />
      </ui-button>
    } @else {
      <ui-button
        type="button"
        size="small"
        mode="outlined"
        [iconOnly]="true"
        (click)="clickRemove.emit()"
      >
        <span class="text-error dark:text-error-darkmode">
          <ng-icon name="heroTrash" size="20" class="!block" />
        </span>
      </ui-button>
    }
  </div>
  <div
    class="h-1.5 w-full bg-surface-highlight dark:bg-surface-highlight-darkmode rounded-full"
    aria-label="Progress {{ progressPercent() }}%"
  >
    <div
      class="h-1.5 rounded-full transition-[width,background-color] ease-linear"
      [style.transitionDuration.ms]="transitionDuration()"
      [style.width.%]="progressPercent()"
      [ngClass]="
        error()
          ? 'bg-error dark:bg-error-darkmode'
          : progressPercent() === 100
            ? 'bg-success dark:bg-success-darkmode'
            : 'bg-primary dark:bg-primary-darkmode'
      "
    ></div>
  </div>
</div>
